<template>
	<el-dialog title="Add Coverage Activities" :visible.sync="showCoverageActivityModal" width="95%"
		custom-class="customClass" top="0" :lock-scroll="true">
		<!-- Add or edit station modal  -->
		<add-or-edit-station :append-to-body="true"></add-or-edit-station>

		<div style="display: flex; justify-content: space-between" class="mb-2">
			<h2 class="popup-title">Add/Edit Coverage Activity</h2>
			<el-button
				icon="el-icon-close"
				size="mini"
				circle
				@click="showCoverageActivityModal = false; resetCoverageActivityModalData();"
			></el-button>
		</div>

		<!-- All filters -->
		<div class="blockquote mb-2">
			<el-row :gutter="20" class="mb-2">
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<p class="font-bold py-1">Section</p>
					<el-select
						v-model="selected_section"
						filterable
						style="width: 100%"
						placeholder="Select Section"
						size="small"
						@change="addNewSection"
					>
						<el-option
							value="add new"
						>
							<span style="color: #f9a168;">Add Section</span>
						</el-option>
						<el-option
							v-for="(section, sectionIndex) in sections"
							:key="'section-' + sectionIndex"
							:value="section.id"
							:label="section.name"
						></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<p class="font-bold py-1">Station</p>
					<el-select
						v-model="selected_functions"
						filterable
						style="width: 100%"
						placeholder="Select Station"
						:disabled="!selected_section"
						size="small"
						@change="addNewStation"
					>
						<el-option
							value="add new"
						>
							<span style="color: #f9a168;">Add-Edit Station</span>
						</el-option>
						<el-option
							v-for="(func, index5) in storeFunctions"
							:key="index5"
							:value="func.id"
							:label="func.function"
							:disabled="selectedFunctionList.includes(func.id)"
							>
							{{ func.function }}
						</el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<p class="font-bold py-1">Planning Type</p>
					<el-select
						v-model="planning_type"
						filterable
						style="width: 100%"
						placeholder="Planning Type"
						:disabled="!selected_section || !selected_functions"
						size="small"
					>
						<el-option
							v-for="(plan, PlanIndex) in planning"
							:key="PlanIndex"
							:value="plan.value"
							:label="plan.name"
							placeholder="Select"
						></el-option>
					</el-select>
				</el-col>
				<!-- Order Type -->
				<el-col v-if="planning_type == 'item prep time per hr' || planning_type == 'transaction per hr'" :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<p class="font-bold py-1">Order Type</p>
					<el-select
							v-model="order_type"
							style="width: 100%;"
						collapse-tags
							:disabled="
								isAdmin != 'admin' ||
								!selected_section ||
								!selected_functions ||
								!planning_type
							"
							placeholder="Select order type"
							filterable
							size="small"
							@change="autoFillCategory"
						>
							<el-option
								v-for="(orderTypeItem, index5) in order_type_list"
								:key="index5"
								:value="orderTypeItem"
								:label="orderTypeItem"
								placeholder="Select"
							>
								{{ orderTypeItem }}
							</el-option>
						</el-select>
				</el-col>
				<!-- Add Time By -->
				<el-col v-if="planning_type == 'item prep time per hr' && order_type" :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
					<p class="font-bold py-1">Add Time By</p>
					<el-select
							v-model="addTime"
							style="width: 100%;"
							collapse-tags
							:disabled="
								isAdmin != 'admin' ||
								!selected_section ||
								!selected_functions ||
								!planning_type ||
								!order_type
							"
							placeholder="Select order type"
							filterable
							size="small"
							@change="autoFillCategory"
						>
							<el-option
								v-for="(Time, index5) in addTime_list"
								:key="index5"
								:value="Time.value"
								:label="Time.name"
								placeholder="Select"
							>
								{{ Time.name }}
							</el-option>
						</el-select>
				</el-col>
			</el-row>
		</div>

		<!-- Number Of Transaction / Hour -->
		<div
			v-if="planning_type == 'transaction per hr' || planning_type == 'quantity' || planning_type == 'footfall per hr'"
			class="blockquote"
		>
			<el-row v-if="planning_type == 'quantity'" :gutter="20" class="my-2">
				<el-col :span="6">
					<p class="font-bold py-1">Planning Level</p>
					<el-select v-model="planning_level" style="width: 100%" placeholder="Planning Level" size="small">
						<el-option value="department" label="Department"></el-option>
						<el-option value="category" label="Category"></el-option>
						<el-option value="subcategory" label="Subcategory"></el-option>
					</el-select>
				</el-col>
				<el-col :span="6">
					<div v-if="planning_level == 'category'">
						<p class="font-bold py-1">Category</p>
						<el-select v-model="selectedCategories" filterable multiple collapse-tags
							style="width: 100%" placeholder="Select Category" size="small">
							<el-option v-for="(Category, PlanIndex) in categoryList" :key="PlanIndex"
								:value="Category.id" :label="Category.name">
							</el-option>
						</el-select>
					</div>

					<div v-else-if="planning_level == 'subcategory'">
						<p class="font-bold py-1">Subcategory</p>
						<el-select v-model="selected_sub_categories" filterable multiple collapse-tags
							style="width: 100%;" placeholder="Select Subcategory" size="small">
							<el-option v-for="(category, index) in subcategory_list" :key="index"
								:value="category.id" :label="category.name">
							</el-option>
						</el-select>
					</div>

					<div v-else-if="planning_level == 'department'">
						<p class="font-bold py-1">Department</p>
						<el-select v-model="select_planning_level_department" filterable multiple
							collapse-tags style="width: 100%" placeholder="Select Department" size="small">
							<!-- <el-option v-for="(department, PlanIndex) in department_list" :key="PlanIndex"
								:value="department.id" :label="department.department">
							</el-option> -->
							<el-option v-for="(department, PlanIndex) in departmentList" :key="PlanIndex"
								:value="department.id" :label="department.name">
							</el-option>
						</el-select>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="mb-2 mt-4">
				<el-col :span="24">
					<h4 v-if="planning_type == 'transaction per hr'" class="mb-2">Number Of Transaction / Hour</h4>
					<h4 v-else-if="planning_type == 'quantity'" class="mb-2">Quantity Sold / Hour</h4>
					<h4 v-else-if="planning_type == 'footfall per hr'" class="mb-2">Number Of Footfall / Hour</h4>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="mb-2">
				<el-col :span="5" class="font-bold">From</el-col>
				<el-col :span="5" class="font-bold">To</el-col>
				<el-col :span="5" class="font-bold">Number of people</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
			<div class="custom-scroll-area__wrapper">
				<el-row v-for="(item, index) in numTeancList" :key="'num-tean-list-'+index" :gutter="20">
					<el-col :span="5">
						<el-select v-model="item.range_start" filterable placeholder="From" size="small">
							<el-option
								v-for="(itemStart, indexStart) in quantityList"
								:key="'start-item-'+indexStart"
								:label="itemStart"
								:value="itemStart"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="5">
						<el-select v-model="item.range_end" filterable placeholder="To" size="small">
							<el-option
								v-for="(itemEnd, indexEnd) in quantityList"
								:key="'end-item-'+indexEnd"
								:label="itemEnd"
								:value="itemEnd"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="5">
						<el-select v-model="item.range_requirement" filterable placeholder="No. of people" size="small">
							<el-option
								v-for="(itemNum, indexNum) in quantityList.filter(el => el <= 100)"
								:key="'num-item-'+indexNum"
								:label="itemNum"
								:value="itemNum"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="2" style="position: relative; height: 50px">
						<img
							src="../../../../../assets/icons/trash-icon.svg"
							width="12"
							class="cursor-pointer mt-4"
							style="position: absolute; left:10px; top: -10px; cursor: pointer;"
							@click="deleteHourTrancAndFootfall(item.id, index)"
						/>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<el-button
							type="text"
							icon="el-icon-circle-plus-outline"
							style="color: #F9A168;"
							size="small"
							@click="addTransactionObj"
						>Add More</el-button>
					</el-col>
				</el-row>
			</div>
		</div>

		<!-- Preparation Activities -->
		<div
			v-if="planning_type == 'item prep time per hr' && addTime"
			class="blockquote"
		>
			<el-row :gutter="20" class="mb-2">
				<el-col :span="24">
					<h4 class="mb-2">Preparation Activities</h4>
					<div>
						<small class="secondary-text">Add approximate time for the preparation of your menu item</small>
					</div>
				</el-col>
			</el-row>
			<div class="custom-scroll-area__wrapper">
				<!-- Add Time By (Overall average time) -->
				<template v-if="addTime === 1">
					<el-row :gutter="20" class="mb-2">
						<el-col :span="6" class="font-bold">&nbsp;</el-col>
						<el-col :span="6" class="font-bold">
							Hours
						</el-col>
						<el-col :span="6" class="font-bold">
							Mins
						</el-col>
						<el-col :span="6" class="font-bold">
							Secs
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="6" class="font-bold">
							<h4 class="m-0">Overall Average Time:</h4>
						</el-col>
						<el-col :span="6">
							<el-select v-model="overall_average.hours" filterable placeholder="Hours" size="small">
								<el-option
									v-for="(item, index) in hoursArr"
									:key="'hour-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="6">
							<el-select v-model="overall_average.minutes" filterable placeholder="Mins" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'min-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="6">
							<el-select v-model="overall_average.seconds" filterable placeholder="Secs" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'sec-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
					</el-row>
				</template>
				<!-- Add Time By (Category) -->
				<template v-else-if="addTime === 2">
					<el-row :gutter="20" class="mb-2">
						<el-col :span="10" class="font-bold">
							Category
						</el-col>
						<el-col :span="4" class="font-bold">
							Hours
						</el-col>
						<el-col :span="4" class="font-bold">
							Mins
						</el-col>
						<el-col :span="4" class="font-bold">
							Secs
						</el-col>
						<el-col :span="2">
							&nbsp;
						</el-col>
					</el-row>
					<el-row v-for="(timeItem, timeIndex) in avgTimePerCategory" :key="'time-item-'+timeIndex" class="mb-2" :gutter="20">
						<el-col :span="10">
							<el-select v-model="timeItem.category" collapse-tags clearable placeholder="Select category" multiple size="small" style="width: 100%">
								<el-option
									v-for="(item, index) in categoryList"
									:key="'category-item-'+index"
									:value="item.id"
									:label="item.name"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="timeItem.hours" filterable placeholder="Hours" size="small">
								<el-option
									v-for="(item, index) in hoursArr"
									:key="'hour-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="timeItem.minutes" filterable placeholder="Mins" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'min-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="timeItem.seconds" filterable placeholder="Secs" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'sec-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="2" style="position: relative;">
							<img
								src="../../../../../assets/icons/trash-icon.svg"
								width="12"
								class="cursor-pointer mt-4"
								style="position: absolute; left:10px; top: -10px; cursor: pointer;"
								@click="deleteCategoryItem(timeIndex)"
							/>
						</el-col>
					</el-row>
					<!-- Add more -->
					<el-row :gutter="20">
						<el-col :span="24">
							<el-button
								type="text"
								icon="el-icon-circle-plus-outline"
								style="color: #F9A168;"
								size="small"
								@click="addMoreCategoryActivities"
							>Add More</el-button>
						</el-col>
					</el-row>
				</template>
				<!-- Add Time By (Sub-category) -->
				<template v-else-if="addTime === 4">
					<el-row :gutter="20" class="mb-2">
						<el-col :span="10" class="font-bold">
							Subcategory
						</el-col>
						<el-col :span="4" class="font-bold">
							Hours
						</el-col>
						<el-col :span="4" class="font-bold">
							Mins
						</el-col>
						<el-col :span="4" class="font-bold">
							Secs
						</el-col>
						<el-col :span="2" class="font-bold">
							&nbsp;
						</el-col>
					</el-row>
					<el-row
						v-for="(subcategoryItem, subcategoryIndex) in sub_category_activity_list"
						:key="'subcategory-item-'+subcategoryIndex"
						:gutter="20"
						class="mb-2"
					>
						<el-col :span="10">
							<el-select v-model="subcategoryItem.subcategory" multiple placeholder="Select Subcategory" size="small" style="width: 100%">
								<el-option
									v-for="(item, index) in subcategory_list"
									:key="'subcategory-item-'+index"
									:value="item.id"
									:label="item.name"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="subcategoryItem.hours" filterable placeholder="Hours" size="small">
								<el-option
									v-for="(item, index) in hoursArr"
									:key="'hour-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="subcategoryItem.minutes" filterable placeholder="Mins" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'min-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="subcategoryItem.seconds" filterable placeholder="Secs" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'sec-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="2" style="position: relative;">
							<img
								src="../../../../../assets/icons/trash-icon.svg"
								width="12"
								class="cursor-pointer mt-4"
								style="position: absolute; left:10px; top: -10px; cursor: pointer;"
								@click="deleteSubcategoryItem(subcategoryIndex)"
							/>
						</el-col>

						<el-col :span="24" class="mt-2">
							<el-row :gutter="20">
								<el-col :span="10">&nbsp;</el-col>
								<el-col :span="14">
									<table style="width: 100%;">
										<tbody>
											<tr v-for="(threshold, threshold_index) in subcategoryItem.transaction_threshold" :key="threshold_index" class="mb-2">
												<td>
													<div class="flex items-center">
														<el-select v-model="threshold.lower_threshold" filterable placeholder="From" style="width: 100px;" size="small">
															<el-option v-for="(item, index) in transaction_threshold_range" :key="index" :value="item.value"
																:label="item.label">
															</el-option>
														</el-select>

														<el-select v-model="threshold.higher_threshold" filterable placeholder="To"
															style="width: 100px; margin-left: 10px;" size="small">
															<el-option v-for="(item, index) in transaction_threshold_range" :key="index" :value="item.value"
																:label="item.label">
															</el-option>
														</el-select>
													</div>
												</td>

												<td>
													<el-select v-model="threshold.hours" v-validate="'required|numeric'" filterable style="width: 100px;" placeholder="Hours" size="small">
														<el-option
															v-for="(item, index) in hoursArr"
															:key="'hour-item-'+index"
															:label="item.label"
															:value="item.value"
														></el-option>
													</el-select>
												</td>

												<td>
													<el-select v-model="threshold.minutes"  v-validate="'required|numeric'" filterable style="width: 100px;" placeholder="Mins" size="small">
														<el-option
															v-for="(item, index) in minsAndSecArr"
															:key="'min-item-'+index"
															:label="item.label"
															:value="item.value"
														></el-option>
													</el-select>
												</td>

												<td>
													<el-select v-model="threshold.seconds"  v-validate="'required|numeric'" filterable style="width: 100px;" placeholder="Secs" size="small">
														<el-option
															v-for="(item, index) in minsAndSecArr"
															:key="'sec-item-'+index"
															:label="item.label"
															:value="item.value"
														></el-option>
													</el-select>
												</td>

												<td>
													<i class="el-icon-delete cursor-pointer default-icon"
														@click="deleteSubCategoryThreshold(subcategoryIndex, threshold_index)"></i>
												</td>
											</tr>

											<tr>
												<td>
													<el-button type="text" icon="el-icon-circle-plus-outline" style="color: #F9A168;" size="small"
														@click="addTransactionThreshold(subcategoryIndex)">
														Add More
													</el-button>
												</td>
											</tr>
										</tbody>
									</table>
								</el-col>
							</el-row>
						</el-col>

					</el-row>
					<!-- Add more -->
					<el-row :gutter="20">
						<el-col :span="24">
							<el-button
								type="text"
								icon="el-icon-circle-plus-outline"
								style="color: #F9A168;"
								size="small"
								@click="addMoreSubcategoryActivities"
							>Add More</el-button>
						</el-col>
					</el-row>
				</template>
				<!-- Add Time By (Department) -->
				<template v-else-if="addTime === 3">
					<el-row :gutter="20" class="mb-2">
						<el-col :span="8" class="font-bold">
							Department
						</el-col>
						<el-col :span="4" class="font-bold">
							Hours
						</el-col>
						<el-col :span="4" class="font-bold">
							Mins
						</el-col>
						<el-col :span="4" class="font-bold">
							Secs
						</el-col>
						<el-col :span="4">
							&nbsp;
						</el-col>
					</el-row>
					<el-row
						v-for="(departmentItem, departmentIndex) in department_activities"
						:key="'department-activities-'+departmentIndex"
						:gutter="20"
						class="mb-2"
					>
						<el-col :span="8">
							<el-select
								v-model="departmentItem.product_department"
								placeholder="Select Department"
								filterable
								size="small"
								style="width: 100%"
							>
								<!-- <el-option
									v-for="(item, index) in departments"
									:key="'department-list-'+index"
									:value="item.id"
									:label="item.department"
								></el-option> -->
								<el-option v-for="(department, PlanIndex) in departmentList" :key="PlanIndex"
									:value="department.id" :label="department.name">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="departmentItem.hours" filterable placeholder="Hours" size="small">
								<el-option
									v-for="(item, index) in hoursArr"
									:key="'hour-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="departmentItem.minutes" filterable placeholder="Mins" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'min-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="departmentItem.seconds" filterable placeholder="Secs" size="small">
								<el-option
									v-for="(item, index) in minsAndSecArr"
									:key="'sec-item-'+index"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="4" style="position: relative;">
							<img
								src="../../../../../assets/icons/trash-icon.svg"
								width="12"
								class="cursor-pointer mt-4"
								style="position: absolute; left:10px; top: -10px; cursor: pointer;"
								@click="deleteDepartmentActivities(departmentIndex)"
							/>
						</el-col>
					</el-row>

					<!-- Add more -->
					<el-row :gutter="20">
						<el-col :span="24">
							<el-button
								type="text"
								icon="el-icon-circle-plus-outline"
								style="color: #F9A168;"
								size="small"
								@click="addMoreDepartmentActivities"
							>Add More</el-button>
						</el-col>
					</el-row>
				</template>
			</div>
		</div>
		<!-- Transaction Activities -->
		<div class="blockquote">
			<el-row :gutter="20" class="mb-2">
				<el-col :span="24">
					<h4>Transaction Activities</h4>
					<div>
						<small class="secondary-text">Add other activities or transaction linked activities</small>
					</div>
				</el-col>
			</el-row>

			<el-row :gutter="20">
				<el-col :span="10">
					<p class="mb-2 font-bold">Activity Title</p>
				</el-col>
				<el-col :span="4">
					<p class="mb-2 font-bold">Order Type</p>
				</el-col>
				<el-col :span="3">
					<p class="mb-2 font-bold">Hours</p>
				</el-col>
				<el-col :span="3">
					<p class="mb-2 font-bold">Mins</p>
				</el-col>
				<el-col :span="3">
					<p class="mb-2 font-bold">Secs</p>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
			</el-row>

			<div class="custom-scroll-area__wrapper">
				<el-row
					v-for="(item, index) in transactionActivities"
					:key="'transaction-activity-item-'+index"
					:gutter="20"
				>
					<el-col :span="10">
						<el-input v-model="item.name" placeholder="Enter activity title" maxlength="60" size="small"></el-input>
						<div class="text-xs text-right">{{ item.name.length }}/60</div>
					</el-col>
					<el-col :span="4">
						<el-select
							v-model="item.order_type"
							style="width: 100%;"
							collapse-tags
							placeholder="Select order type"
							size="small"
							@change="autoFillCategory"
						>
							<el-option
								v-for="(orderTypeItem, index5) in order_type_list"
								:key="index5"
								:value="orderTypeItem"
								:label="orderTypeItem"
								placeholder="Select"
							>
								{{ orderTypeItem }}
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="3">
						<el-select v-model="item.hours" filterable placeholder="Hours" size="small">
							<el-option
								v-for="(hoursItem, hoursIndex) in hoursArr"
								:key="'hour-item-'+hoursIndex"
								:label="hoursItem.label"
								:value="hoursItem.value"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="3">
						<el-select v-model="item.minutes" filterable placeholder="Mins" size="small">
							<el-option
								v-for="(itemMins, indexMins) in minsAndSecArr"
								:key="'min-item-'+indexMins"
								:label="itemMins.label"
								:value="itemMins.value"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="3">
						<el-select v-model="item.seconds" filterable placeholder="Secs" size="small">
							<el-option
								v-for="(itemSecs, indexSecs) in minsAndSecArr"
								:key="'sec-item-'+indexSecs"
								:label="itemSecs.label"
								:value="itemSecs.value"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="1" style="position: relative; height: 50px">
						<img
							src="../../../../../assets/icons/trash-icon.svg"
							width="12"
							class="cursor-pointer mt-4"
							style="position: absolute; left:10px; top: -10px; cursor: pointer;"
							@click="removeTransactionActivity(index)"
						/>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="24">
						<el-button type="text" icon="el-icon-circle-plus-outline" style="color: #F9A168;" size="small" @click="addMoreTransactionCoverageActivity">Add More</el-button>
					</el-col>
				</el-row>
			</div>
		</div>

		<span slot="footer">
			<el-row :gutter="20">
				<el-col :span="24" class="text-right">
					<el-button
						v-if="planning_type == 'item prep time per hr'"
						type="warning"
						size="small"
						class="primary-settings-button__save"
						round
						@click="addActivity"
					>Save</el-button>
					<el-button
						v-else
						type="warning"
						size="small"
						class="primary-settings-button__save"
						round
						@click="addHourActivity"
					>Save</el-button>
				</el-col>
			</el-row>
		</span>
	</el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
import AddOrEditStation from "./AddOrEditStation.vue";
export default {
	name: "AddOrEditCoverageActivities",
	components: {
		AddOrEditStation,
	},
	mixins: [settingsMixin],
	watch: {
		selected_section(newVal, oldVal) {
			if(newVal) {
				this.avgTimePerCategory = this.avgTimePerCategory.map((el) => ({
					...el,
					store_section: newVal
				}))
			}
		}
	}
};
</script>

<style lang="scss">
.company-settings .customClass {
	position: absolute;
	right: 0;
	height: 100vh;
	overflow: auto;
	.el-dialog__header {
		display: none;
	}
	.primary-text {
		color: #f9a168;
	}
	.secondary-text {
		color: #999999;
	}
	.custom-scroll-area__wrapper {
		max-height: 150px;
		overflow-y: auto;
		overflow-x: hidden;
		::-webkit-scrollbar {
			-webkit-appearance: none !important;
			width: 7px !important;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px !important;
			background-color: rgba(0, 0, 0, .5) !important;
			box-shadow: 0 0 1px rgba(255, 255, 255, .5) !important;
		}
	}
	.blockquote {
		padding: 20px;
		margin-bottom: 15px;
		/* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
		border: 1px solid #c4c4c4;
		border-radius: 4px;
	}
}
.store-settings .customClass {
	position: absolute;
	right: 0;
	height: 100vh;
	overflow: auto;
	.el-dialog__header {
		display: none;
	}
	.primary-text {
		color: #f9a168;
	}
	.secondary-text {
		color: #999999;
	}
	.custom-scroll-area__wrapper {
		max-height: 250px;
		overflow-y: auto;
		overflow-x: auto;
		::-webkit-scrollbar {
			-webkit-appearance: none !important;
			width: 7px !important;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px !important;
			background-color: rgba(0, 0, 0, .5) !important;
			box-shadow: 0 0 1px rgba(255, 255, 255, .5) !important;
		}
	}
	.blockquote {
		padding: 20px;
		margin-bottom: 15px;
		/* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
		border: 1px solid #c4c4c4;
		border-radius: 4px;
	}
}
</style>
